if (!customElements.get('media-wall')) {
  customElements.define('media-wall', class MediaWall extends Slider {
    connectedCallback() {
      if (this.initSliderStatus) this.hookAfterInstall();
    }
    hookAfterInstall() {
      if (!this.curioViewportObserver) {
        this.curioInViewport = false;
        this.curioViewportObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            this.curioInViewport = entry.isIntersecting;
            this.playVideosWhenVisible();
          });
        }, {threshold: 0.01});
        this.curioViewportObserver.observe(this);
        this.curioVisibilityHandler = () => this.playVideosWhenVisible();
        document.addEventListener('visibilitychange', this.curioVisibilityHandler);
        this.curioPlayHandler = event => {
          if (event.target.tagName !== 'VIDEO') return;
          const slide = event.target.closest('.slider-slide');
          if (!this.curioInViewport || document.hidden || !this.isVisibleSlide(slide)) event.target.pause();
        };
        this.addEventListener('play', this.curioPlayHandler, true);
      }
      this.playVideosWhenVisible();
    }
    updateInfo() {
      super.updateInfo();
      this.playVideosWhenVisible();
    }
    playVideosWhenVisible() {
      if (!this.sliderItems) return;
      const visible = this.curioInViewport && !document.hidden;
      this.sliderItems.forEach(element => {
        if (visible && this.isVisibleSlide(element)) {
          element.querySelectorAll('video').forEach(video => {
            if (video.paused) {
              const playing = video.play();
              if (playing?.catch) playing.catch(() => {});
            }
          });
          element.querySelectorAll('.js-youtube').forEach(video => video.contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*'));
          element.querySelectorAll('.js-vimeo').forEach(video => video.contentWindow.postMessage('{"method":"play"}', '*'));
        } else {
          webvista.pauseAllMedia(element);
        }
      });
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      this.curioViewportObserver?.disconnect();
      this.curioViewportObserver = null;
      if (this.curioVisibilityHandler) document.removeEventListener('visibilitychange', this.curioVisibilityHandler);
      if (this.curioPlayHandler) this.removeEventListener('play', this.curioPlayHandler, true);
      webvista.pauseAllMedia(this);
    }
  });
}
